<template>
  <div id="app" class="inclusionCurriculum">
    <nav-component></nav-component>
    <hero-component></hero-component>
    <accordian-component></accordian-component>
    <footer-component></footer-component>
  </div>
</template>

<script>
  import AccordianComponent from "../components/accordianComponent"
  import NavComponent from "../components/NavComponent.vue";
  import HeroComponent from "../components/StaticHero.vue";
  import FooterComponent from "../components/FooterComponent.vue";
  import SuccessComponent from "../components/SuccessComponent.vue";

  export default {
    metaInfo() {
        return {
            title: `About | Starbucks Coffee Academy`,
            meta: [{ rel: 'canonical', href: 'https://starbuckscoffeeacademy.com/about'},]
        }
    },
    name: "app",
    components: {
      NavComponent,
      HeroComponent,
      FooterComponent,
      SuccessComponent,
       AccordianComponent
    },
    data() {
      return {
        currentStep: 0
      };
    },
    created() {
      console.log("STORE ACCESS= ",this.$store.state.currentStep)
    }
  };
</script>